import * as React from "react";
import { Dispatch, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { upperCaseFirst, constant } from "change-case";
import { FundExplorerPage } from '../components/FundExplorerPage/FundExplorerPage'
import { IState, IWatchlist, IDataEntity, IDataEntityResponse, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, ISearch, IAppParams, ITypeahead, ISorting, IInifiniteScroll, IModals } from "../models";
import { getFunds, getFilters, changeFilter, toggleFund, toggleShareClass, toggleAllFunds, toggleShareClassPerformance, changeSortOrder, editWatchlist, execInfiniteScroll, getDisclaimers, toggleModal, getSharePriceFundList, GET_SHARE_PRICE_FUNDLIST } from "../actions";
import { BASE_SEARCH_REQUEST } from "../data";

interface IIdentifierSearch {
	properties: string[];
	value?: string;
	fuzzy: boolean;
};

interface IProps {
	route?: { appParams: IAppParams }
	disclaimers?: {};
	isLoading?: boolean;
	appParams?: IAppParams;
	getFunds?: typeof getFunds;
	funds?: IDataEntityResponse;
	filterOptions?: IFundFilterResponse & IShareClassFilterResponse;
	filter?: IFilterRequest;
	typeahead?: ITypeahead[];
	changeFilter?: typeof changeFilter;
	getFilters?: typeof getFilters;
	collapsedFunds?: string[];
	toggleFund?: typeof toggleFund;
	toggleShareClass?: typeof toggleShareClass;
	toggleShareClassPerformance?: typeof toggleShareClassPerformance;
	toggleAllFunds?: typeof toggleAllFunds;
	changeSortOrder?: typeof changeSortOrder;
	sorting?: ISorting;
	editWatchlist?: typeof editWatchlist;
	watchlist?: IWatchlist[];
	infiniteScroll?: IInifiniteScroll;
	execInfiniteScroll?: typeof execInfiniteScroll;
	getDisclaimers?: typeof getDisclaimers;
	modals?: IModals;
	benchmarks?: IDataEntity[];
	toggleModal?: typeof toggleModal;
	getSharePriceFundList?: typeof getSharePriceFundList;
	sharePriceFundList?: any;
}

@connect(mapStateToProps, mapDispatchToProps)
export class FundExplorer extends React.Component<React.Props<{}> & IProps, {}>{
	componentWillMount() {
		this.props.getFilters({}, this.props.appParams);
		this.doFilterRequest();
		this.props.getDisclaimers(this.props.appParams);
		this.props.getFunds(Object.assign({}, BASE_SEARCH_REQUEST, { limit: 1000 }), this.props.appParams, true, 0);
		this.props.getSharePriceFundList();
	}

	doFilterRequest() {
		let shouldCallDB = true;
		let locationURI = location.search;
		let queryString = locationURI.split("?");
		let searchItems = [];
		let identifierSearch: IIdentifierSearch = {
			properties: [
				"fund_name"
			],
			fuzzy: false
		};
		if (queryString.length > 1) {
			let queryStringItems = queryString.pop().split("&");
			for (let item of queryStringItems) {
				let keyValue = item.split("=");
				if (keyValue[0] === "term") {
					// If we have a term search the Search component will activate the search
					shouldCallDB = false;
				}
				else if (keyValue[0] === "isins" && keyValue[1]) {
					searchItems.push({
						property: "isin",
						matchtype: 'MATCH',
						values: [...keyValue[1].toUpperCase().split(",")]
					});
				}
				else {
					let property = decodeURIComponent(keyValue[0]);
					let value = decodeURIComponent(decodeURI(keyValue[1]));

					let values = [];
					if (property === 'asset_class') {
						value = upperCaseFirst(value);
						values.push(value);
					}
					else if (property === "fund_name") {
						Object.assign(identifierSearch, { value: value.toLowerCase() });
					}
					else {
						values.push(value);
					}

					if (!identifierSearch.value) {
						searchItems.push({
							property,
							matchtype: 'MATCH',
							values
						});
					}
				}
			}
		}

		let filterObject = {};
		if (identifierSearch.value) {
			Object.assign(filterObject, { search: [...searchItems] }, { identifierSearch });
		} else {
			Object.assign(filterObject, { search: [...searchItems] });
		}

		if (shouldCallDB) {
			this.props.changeFilter(filterObject, this.props.appParams);
		}
	}

	render() {
		let { filterOptions } = this.props;
		if (Object.keys(filterOptions).length === 0) {
			return <div></div>;
		}

		return (
			<div className="ktsys-fund-explorer">
				<FundExplorerPage { ...this.props } />
			</div>
		);
	}
}

function mapStateToProps(state: IState, ownProps: any): IProps {
	return {
		isLoading: state.loading.isLoading,
		funds: state.funds,
		filterOptions: state.filterOptions,
		typeahead: state.typeahead as ITypeahead[],
		filter: state.filter,
		collapsedFunds: state.collapsedFunds,
		sorting: state.sorting,
		watchlist: state.watchlist,
		infiniteScroll: state.infiniteScroll,
		disclaimers: state.disclaimers,
		benchmarks: state.benchmarks,
		modals: state.modals,
		sharePriceFundList: state.sharePriceFundList,
	};
}

function mapDispatchToProps(dispatch: Dispatch<IState>): IProps {
	return {
		getFunds: bindActionCreators(getFunds, dispatch),
		getFilters: bindActionCreators(getFilters, dispatch),
		changeFilter: bindActionCreators(changeFilter, dispatch),
		toggleShareClassPerformance: bindActionCreators(toggleShareClassPerformance, dispatch),
		toggleShareClass: bindActionCreators(toggleShareClass, dispatch),
		toggleFund: bindActionCreators(toggleFund, dispatch),
		toggleAllFunds: bindActionCreators(toggleAllFunds, dispatch),
		changeSortOrder: bindActionCreators(changeSortOrder, dispatch),
		editWatchlist: bindActionCreators(editWatchlist, dispatch),
		execInfiniteScroll: bindActionCreators(execInfiniteScroll, dispatch),
		getDisclaimers: bindActionCreators(getDisclaimers, dispatch),
		toggleModal: bindActionCreators(toggleModal, dispatch),
		getSharePriceFundList: bindActionCreators(getSharePriceFundList, dispatch),
	};
}



// WEBPACK FOOTER //
// ./src/client/containers/FundExplorer.tsx